<template>
  <div>
    <div class="vx-card">
      <div class="vx-card__body card-body">
        <div class="vx-row">
          <div class="vx-col w-full mb-base">
            <data-grid
              ref="grid"
              stripe
              :data-source="gridDataSource"
              :search-data="gridSearchData"
              :columns="[
                { title: $t('Firstname') },
                { title: $t('Lastname') },
                { title: $t('TypesOfCooperation') },
                { title: $t('CreateOn'), sort: 'CreateOn' },
                { title: $t('Action') }
              ]"
            >
              <template slot-scope="{ row }">
                <td style="width: 20%">{{ row.firstName }}</td>
                <td style="width: 20%">
                  {{ row.lastName }}
                </td>
                <td style="width: 27%">
                  {{ row.typesOfCooperation }}
                </td>
                <td style="width: 15%">
                   {{ row.createOn.split(" ")[0] }}<br />{{
                  row.createOn.split(" ")[1]
                }}
                </td>
                <td style="width: 15%">
                  <router-link
                    :to="{ path: '/RecruitmentRequest/Details/' + row.id }"
                  >
                    <vs-button
                      color="primary"
                      type="border"
                      icon-pack="feather"
                      icon="icon-eye"
                      class="view-details"
                      v-has-permission="permission188"
                      >{{ $t("ViewDetails") }}</vs-button
                    >
                  </router-link>
                </td>
              </template>
            </data-grid>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.view-details {
  padding: 0.1rem 0.75rem !important;
  display: inline-block;
  margin: 0.4rem 0 0.2rem 0;
}

.view-details i {
  padding-left: 0.2rem;
  position: relative;
  top: 2px;
  display: inline-block;
}
</style>
<script>
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import DataGrid from "@/components/datagrid/DataGrid";

export default {
  name: "Content_management_RecruitmentRequest_Index",
  components: {
    DataGrid
  },
  data() {
    return {
      gridDataSource: {
        type: "app",
        service: "HRM/api/RecruitmentsQuery"
      },
      gridSearchData: {
        keyword: ""
      }
    };
  }
};
</script>
